import BaseAPI from './base/base-api';

class AgreementAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'ManagementAPI';
    controllerName = 'agreement';
}

export default new AgreementAPI();